export type paginationType = {
  current_page: number
  per_page: number
  total: number
  total_pages: number
}

const getPagination = (
  total: number,
  current_page: number | string = 1,
  per_page: number = 24
): paginationType => {
  const total_pages = Math.ceil(total / per_page)
  return {
    current_page: Number(current_page) || 1,
    per_page: Number(per_page) || 1,
    total: Number(total),
    total_pages: Number(total_pages) || 1,
  }
}

export default getPagination
